"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _video = require("../utils/video");
var _CardMedia = _interopRequireDefault(require("./styles/CardMedia"));
var _cardStyling = _interopRequireDefault(require("./styles/cardStyling"));
const CardMedia = ({
  card,
  style
}) => {
  const {
    type,
    url,
    videoCaptionsFile,
    videoCaptionsFileLocale,
    videoCaptionsFileLang,
    videoPoster,
    isMobile,
    containerClassName,
    testId = 'cardMedia',
    dataCy = 'cardMedia'
  } = card;
  return /*#__PURE__*/_react.default.createElement(_cardStyling.default, {
    className: (0, _classnames.default)('border', containerClassName, {
      'p-3': isMobile,
      'p-4': !isMobile
    }),
    style: {
      ...style
    },
    "data-testid": testId,
    "data-cy": dataCy
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `card-body d-flex justify-content-center align-items-center ${_CardMedia.default} p-0`
  }, type === 'Video' ?
  /*#__PURE__*/
  /* eslint-disable jsx-a11y/media-has-caption */
  _react.default.createElement("video", (0, _extends2.default)({
    className: "card-media-wh",
    controls: true,
    poster: videoPoster
  }, window.Cypress && {
    preload: 'none'
  }), /*#__PURE__*/_react.default.createElement("source", {
    src: url,
    type: (0, _video.getVideoType)(url)
  }), videoCaptionsFile && /*#__PURE__*/_react.default.createElement("track", {
    kind: "captions",
    src: videoCaptionsFile,
    srcLang: videoCaptionsFileLocale,
    label: videoCaptionsFileLang
  })) : /*#__PURE__*/_react.default.createElement("img", {
    src: url,
    alt: "card",
    className: "card-media-wh"
  })));
};
CardMedia.propTypes = {
  style: _propTypes.default.object,
  card: _propTypes.default.shape({
    type: _propTypes.default.oneOf(['Video', 'Image']).isRequired,
    url: _propTypes.default.string.isRequired,
    videoCaptionsFile: _propTypes.default.string,
    videoCaptionsFileLocale: _propTypes.default.string,
    videoCaptionsFileLang: _propTypes.default.string,
    videoPoster: _propTypes.default.string,
    isMobile: _propTypes.default.bool,
    containerClassName: _propTypes.default.string,
    testId: _propTypes.default.string,
    dataCy: _propTypes.default.string
  }).isRequired
};
var _default = exports.default = CardMedia;